module.exports = __webpack_public_path__ + "03dd14f9708134b1f30726756931765c.svg";